// pricing-slider.component.ts

import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { lastValueFrom } from 'rxjs';
import { MoneyModel } from 'src/app/models/sales-funnel';
import { ApiService } from '../../services';

@Component({
  selector: 'app-pricing-slider',
  templateUrl: './pricing-slider.component.html',
  styleUrls: ['./pricing-slider.component.css']
})
export class PricingSliderComponent implements OnInit {
  minValue: number = 1;
  maxValue: number = 1000;

  currencies: any[] = []

  @Input()  sliderValue: Partial<MoneyModel>  = {
    currency: {
      id: 1,
    },
    value: 20
  };
  @Output() sliderValueChange = new EventEmitter<Partial<MoneyModel>>();
  @Output() sliderPriceValueChange = new EventEmitter<number>();
  @Output() sliderPriceCurrencyChange = new EventEmitter<{id: number}>();

  @Input() manually = false;
  @Input() disableSmartMode: boolean = false;

  constructor(private api: ApiService) {

  }

  async ngOnInit() {
    await this.getCurrencies()
  }

  async getCurrencies() {
    const request$ = this.api.getCurrencies();
    const response = await lastValueFrom(request$);
    console.log(response);
    this.currencies = response;

    return response;
  }

  currencyChange(id: number) {
    console.log(id);
    const selectedCurrency = this.currencies.find((currency) => currency.id == id);
    this.sliderValue.currency = selectedCurrency;
    this.emitChanges()
  }

  valueChange(value: number) {
    this.sliderValue.value = value;
    if (value >= this.maxValue * 0.9 && this.maxValue < 150000) {
      this.maxValue = Math.floor(this.maxValue + 10)
    }
    this.emitChanges()
  }

  emitChanges() {
    this.sliderValueChange.emit(this.sliderValue);
    this.sliderPriceValueChange.emit(this.sliderValue.value)
  }

}
